import FilterItem, { FilterItemProps } from './FilterItem';

export type { FilterItemProps };
export default FilterItem;
